// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2Ld2a","label":"CategoryService_label__2HIis","location":"CategoryService_location__R3KEp"};